export default __webpack_public_path__ + "static/vienna-9547e6b86c326230daa140412451db92.png";